import Proptypes from 'prop-types';
import React from 'react';
import * as svgIcons from '../Icons/ProjectTypeIcons';
import { useLoaded } from '../../../../helpers/utils';

const ProjectTypeIcon = ({ iconName }) => {
  const RelevantIcon = svgIcons[iconName.replace(' ', '')];

  // Only render SVGs on client side to prevent hydration errors
  const loaded = useLoaded();

  return (
    <div className="project-type-icon">
      <div className="svg-wrapper">
        {loaded && <RelevantIcon />}
      </div>
    </div>
  );
};

ProjectTypeIcon.propTypes = {
  iconName: Proptypes.string.isRequired,
};

export default ProjectTypeIcon;
